/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { ImageCropperModule } from 'ngx-image-cropper';
import { of as observableOf } from 'rxjs';
import {
    NbChatModule,
    NbDatepickerModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule,
    NbWindowModule,
    NbSpinnerModule
} from "@nebular/theme";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { LoginComponent } from "./login/login.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInspectorService } from "./services/token-inspector/token-inspector.service";
import { TreeviewModule } from "ngx-treeview";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DecimalPipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgSelectizeModule } from 'ng-selectize';
import { NbAuthModule } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';

export class NbSimpleRoleProvider extends NbRoleProvider {
    getRole() {
      // here you could provide any role based on any auth flow
      return observableOf('guest');
    }
  }

@NgModule({
    declarations: [AppComponent, LoginComponent, ForgotPasswordComponent, ResetPasswordComponent],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        Ng2SmartTableModule,
        NgSelectModule,
        ThemeModule.forRoot(),
        NbSpinnerModule,
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbChatModule.forRoot({
            messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY"
        }),
        TreeviewModule,
        NgSelectizeModule,
        ImageCropperModule,
        NbAuthModule.forRoot(),
        NbSecurityModule.forRoot(),
    ],
    exports: [LoginComponent],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInspectorService,
            multi: true
        },
        {
            provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
          },
        DecimalPipe
    ]
})
export class AppModule { }
